module.exports = __webpack_public_path__ + "static/img/NA.89aeeb61.svg";